import React from 'react';

export const AddClient = () => {
	return (
		<div>Add Client</div>
	)
}